import { translateFrToEn } from 'lib/translationService'

const STANDARD_HIRING_TEMPLATE_NAMES = {
  fr: 'Processus de recrutement standard',
  en: 'Standard Hiring Process',
} as const

const HIRING_TEMPLATE_NAME_ALIASES: Record<string, { fr: string; en: string }> = {
  [STANDARD_HIRING_TEMPLATE_NAMES.fr.toLowerCase()]: {
    fr: STANDARD_HIRING_TEMPLATE_NAMES.fr,
    en: STANDARD_HIRING_TEMPLATE_NAMES.en,
  },
  [STANDARD_HIRING_TEMPLATE_NAMES.en.toLowerCase()]: {
    fr: STANDARD_HIRING_TEMPLATE_NAMES.fr,
    en: STANDARD_HIRING_TEMPLATE_NAMES.en,
  },
}

const localeKey = (language: string): 'fr' | 'en' =>
  language.startsWith('en') ? 'en' : 'fr'

export function getKnownHiringTemplateDisplayName(
  name: string | null | undefined,
  language: string
): string | null {
  if (!name?.trim()) return null

  const mapping = HIRING_TEMPLATE_NAME_ALIASES[name.trim().toLowerCase()]
  if (mapping) {
    return mapping[localeKey(language)]
  }

  return null
}

export async function resolveHiringTemplateDisplayName(
  name: string | null | undefined,
  language: string
): Promise<string | null> {
  if (!name?.trim()) return null

  const known = getKnownHiringTemplateDisplayName(name, language)
  if (known) return known

  if (localeKey(language) === 'en') {
    return translateFrToEn(name)
  }

  return name
}
